<template>
    <div>
        <a-card title="参数设置" style="margin-bottom: 30px;">
            <a-form-model
                :model="formRelevant.data"
                :label-col="{span: 6}"
                :wrapper-col="{span: 16}"
                ref="ruleForm">
                <div style="padding-left: 30px;">
                    有效分数：
                    <a-select v-model="formRelevant.data.scoreRangeType" style="width: 120px;margin-right: 20px;" placeholder="请选择" :disabled="IsDetails">
                        <a-select-option :value="0">
                            单个任务
                        </a-select-option>
                        <a-select-option :value="1">
                            全部任务
                        </a-select-option>
                    </a-select>
                    <a-input-number :min="50" :max="150" placeholder="请输入最小值" :disabled="IsDetails"
                                    v-model="formRelevant.data.lowerEffectiveScore" style="width: 120px;"/>
                    <span style="margin: 0 10px 20px;">-</span>
                    <a-input-number :min="formRelevant.data.lowerEffectiveScore ? formRelevant.data.lowerEffectiveScore + 1 : 50" :max="150" :disabled="IsDetails"
                                    placeholder="请输入最大值" v-model="formRelevant.data.upperEffectiveScore" style="width: 120px;"/>
                    <span style="margin-left: 20px;">( 请输入50-150的数字 )</span>
                </div>
                <div style="padding-left: 30px;margin-top: 30px;">
                    生成PPT：
                    <a-switch v-model="formRelevant.data.isGeneratePPT " checked-children="开启" un-checked-children="关闭" :disabled="IsDetails" />
                </div>
                <div style="padding-left: 30px;margin-top: 30px;">
                    校正算法：
                    <a-radio-group v-model="formRelevant.data.correctionMethod" :disabled="IsDetails">
                        <a-radio :value="0">不校正</a-radio>
                        <a-radio :value="1">系数校正</a-radio>
                        <a-radio :value="2">标准差校正</a-radio>
                    </a-radio-group>
                </div>
            </a-form-model>
        </a-card>
        <a-card title="重点数据" style="margin-bottom: 30px;">
            <div style="margin-bottom: 30px;padding-left: 30px;">
                正向数据：前
                <a-input-number :min="0" placeholder="请输入" :precision="0" :disabled="IsDetails"
                                v-model="formRelevant.data.betterCount" style="width: 180px;"/>
                名
            </div>
            <div style="padding-left: 30px;">
                负向数据：后
                <a-input-number :min="0" placeholder="请输入" :precision="0" :disabled="IsDetails"
                                v-model="formRelevant.data.poorCount" style="width: 180px;"/>
                名
            </div>
        </a-card>
        <div v-if="!IsDetails" style="text-align: right;margin: 30px 0;padding-right: 50px;">
            <a-button @click="$parent.$data.current = 2" style="margin-right: 20px;">上一步</a-button>
            <a-button type="primary" :loading="formRelevant.loading" @click="submit">生成报告</a-button>
        </div>
    </div>
</template>

<script>
import $Bus from "@/pages/projectImpl/js/eventBus";
import {tableRelevant, FormatDate} from "@/pages/projectImpl/js/utils";

const columns = [
    {title: '考试名称',dataIndex: 'examName',key: 'examName',align: 'center'},
    {title: '考试学期',scopedSlots: { customRender: 'term' },width:100,align: 'center'},
    {title: '考试类型',scopedSlots: { customRender: 'examType' },key: 'examType',align: 'center'},
    {title: '关联科目',dataIndex: 'relatedSubject',key: 'relatedSubject',ellipsis: true, align: 'center'},
    {title: '班级数',dataIndex: 'classCount',key: 'classCount',width:100, align: 'center'},
    {title: '学生数',dataIndex: 'userCount',key: 'userCount',width:100, align: 'center'},
    {title: '文件名称',dataIndex: 'fileName',key: 'fileName',align: 'center'},
]
export default {
    name: "StepsFourth",
    props: {
        IsDetails: false
    },
    data() {
        return {
            //当前报告信息
            reportInfo: this.$store.getters['organization/getReportInfo'],
            reportId: this.$store.getters['organization/getReportInfo'].id,
            formRelevant: {
                loading: false,
                data: {
                    lowerEffectiveScore: 50,
                    upperEffectiveScore : 150,
                    betterCount: 0,
                    poorCount: 0,
                    isGeneratePPT: false,
                    correctionMethod: 1,
                    scoreRangeType : 0,
                    pupilExamId:undefined
                },
            },
        }
    },
    created() {
        console.log(this.$store.getters['organization/getReportInfo']);
        for (let key in this.formRelevant.data) {
            if (key === "upperEffectiveScore" || key === "lowerEffectiveScore"){
                this.formRelevant.data[key] = this.$store.getters['organization/getReportInfo'][key] || undefined;
            } else {
                this.formRelevant.data[key] = this.$store.getters['organization/getReportInfo'][key];
            }
        }
        if (this.IsDetails) {
            this.getModel()
        }
    },
    methods: {
        //根据id获取团体报告信息
        getModel() {
            this.$http.GroupReport.getModel({id: this.reportId})
                .then(res => {
                    for (let key in this.formRelevant.data) {
                        this.formRelevant.data[key] = res.data[key];
                    }
                })
        },
        submit() {
            const form = {
                lowerEffectiveScore: this.formRelevant.data.lowerEffectiveScore || 50,
                upperEffectiveScore: this.formRelevant.data.upperEffectiveScore || 150,
                betterCount: this.formRelevant.data.betterCount || 0,
                poorCount: this.formRelevant.data.poorCount || 0,
                pupilExamId: this.formRelevant.data.pupilExamId,
                scoreRangeType: this.formRelevant.data.scoreRangeType || 0,
                isGeneratePPT: this.formRelevant.data.isGeneratePPT,
                correctionMethod: this.formRelevant.data.correctionMethod,
                studentSampleTakingMethod: this.reportInfo.studentSampleTakingMethod,
                id: this.reportInfo.id,
                nameCN: this.reportInfo.nameCN,
                nameEN: this.reportInfo.nameEN,
                projectName: this.reportInfo.projectName,
                reportTime: this.reportInfo.reportTime,
                projectCourseConfigId: this.reportInfo.projectCourseConfigId || undefined,
                reportType: this.reportInfo.reportType,
                status: 2,
                contrastDimension: this.reportInfo.contrastDimension,
                createReportTime: FormatDate(Date.now(), "YYYY-MM-DD hh:mm:ss"),
            };
            console.log(form)
            this.formRelevant.loading = true;
            this.$http.GroupReport.groupReportEdit(form)
                .then(res => {
                    /*this.$store.commit('organization/setReportInfo', form);
                    this.$parent.$data.current = 3;*/
                    this.$message.success(res.message);
                    $Bus.$emit("closeCreateReport");
                }).finally(() => {
              this.formRelevant.loading = false;
            })
        },
    }
}
</script>

<style scoped>
.age {
    margin-top: 15px;
    margin-bottom: 0;
}

.age /deep/ .ant-form-item {
    width: 50%;
    height: 60px;
    margin-bottom: 0;
}

.age-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.exam{
        padding: 2px 30px 2px 10px;
        background: #f1f1f1;
        border-radius: 4px;
        margin-right: 20px;
        position: relative;
    }
    .exicon{
        position: absolute;
        top: 7px;
        right: 8px;
        font-size: 10px;
        cursor: pointer;
    }
    .noClose{
        cursor: no-drop;
    }
</style>
